import BookingsPage from "./bookings";

export default BookingsPage;